var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeWidget)?_c('div',[(_vm.activeWidget.content.type == 'map' && _vm.activeWidget.content.data && _vm.activeWidget.content.data.myMap)?[_c('MyTabs',{attrs:{"tabs":_vm.tabs,"data":_vm.activeWidget.content.data}})]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }